module.exports = __webpack_public_path__ + "img/odisha_1.75abf79d.png";